import SegmentedButton from './SegmentedButton'

export default SegmentedButton
